module.exports = __webpack_public_path__ + "static/img/四川考察.0ce7b7c4.jpg";